/**
 * Empty data structure fallbacks for analytics endpoints
 */

export const getEmptyPatientStats = () => ({
  total: 0,
  new: 0,
  returning: 0,
  pending: 0,
  completed: 0,
  needsAttention: 0,
  byAge: {
    '18-30': 0,
    '31-45': 0,
    '46-60': 0,
    '61+': 0
  },
  byGender: {
    male: 0,
    female: 0,
    other: 0,
    unknown: 0
  },
  byRisk: {
    low: 0,
    medium: 0,
    high: 0,
    critical: 0
  }
});

export const getEmptyScreeningStats = () => ({
  total: 0,
  bloodPressure: 0,
  cholesterol: 0,
  glucose: 0,
  bmi: 0,
  heartRate: 0,
  lpa: 0,
  avgProcessingTime: 0,
  byMonth: []
});

export const getEmptyEventStats = () => ({
  total: 0,
  active: 0,
  completed: 0,
  avgAttendance: 0,
  totalAttendees: 0,
  byType: {
    health_screening: 0,
    blood_drive: 0,
    educational_workshop: 0
  },
  upcomingEvents: []
});

export const getEmptyRiskAnalysis = () => ({
  highRisk: 0,
  distribution: [
    { name: 'Low Risk', value: 0, percentage: 0, color: '#52c41a' },
    { name: 'Medium Risk', value: 0, percentage: 0, color: '#faad14' },
    { name: 'High Risk', value: 0, percentage: 0, color: '#ff4d4f' },
    { name: 'Critical', value: 0, percentage: 0, color: '#a8071a' }
  ],
  riskFactors: [],
  followUpRequired: 0
});

export const getEmptyTrendsData = () => ({
  growth: 0,
  monthlyData: [],
  dailyAverages: {
    screenings: 0,
    newPatients: 0,
    volunteers: 0
  }
});

export const getEmptyVolunteerData = () => ({
  total: 0,
  active: 0,
  topVolunteers: [],
  performance: {
    avgScreeningsPerVolunteer: 0,
    avgHoursPerVolunteer: 0,
    avgRating: 0,
    totalHours: 0
  }
});

export const getEmptyQueueStats = () => ({
  total: 0,
  pending_review: 0,
  new_patient: 0,
  in_progress: 0,
  completed: 0,
  needs_attention: 0,
  avgWaitTime: 0,
  avgProcessingTime: 0
});

export const getEmptyDetailedData = () => ({
  patients: [],
  screenings: [],
  events: [],
  volunteers: [],
  exportTimestamp: new Date().toISOString()
});

export const getEmptyQueueAnalytics = () => ({
  totalEntries: 0,
  statusBreakdown: {},
  eventBreakdown: {},
  patientFlow: {
    completed: 0,
    archived: 0,
    pending: 0,
    inProgress: 0
  },
  eventDetails: {},
  timeDistribution: {}
});
